import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPerson = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M12 11.9832C10.9 11.9832 9.98608 11.6194 9.25825 10.8917C8.53058 10.1639 8.16675 9.24999 8.16675 8.14999C8.16675 7.04999 8.53058 6.13608 9.25825 5.40824C9.98608 4.68058 10.9 4.31674 12 4.31674C13.1 4.31674 14.0139 4.68058 14.7417 5.40824C15.4694 6.13608 15.8333 7.04999 15.8333 8.14999C15.8333 9.24999 15.4694 10.1639 14.7417 10.8917C14.0139 11.6194 13.1 11.9832 12 11.9832ZM4 20V17.5C4 16.8888 4.15417 16.3541 4.4625 15.8957C4.77083 15.4374 5.17225 15.0888 5.66675 14.85C6.75558 14.3445 7.81942 13.9653 8.85825 13.7125C9.89725 13.4597 10.9445 13.3332 12 13.3332C13.0555 13.3332 14.0999 13.4624 15.1333 13.7207C16.1666 13.9791 17.2277 14.3555 18.3167 14.85C18.8222 15.0888 19.2292 15.4374 19.5375 15.8957C19.8458 16.3541 20 16.8888 20 17.5V20H4Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgPerson);
export default ForwardRef;
